import { LOCALES, invoke, replacePath, web3Navigate } from '@web3/utils';
import { useLocale } from '../../../../store/i18nMessage';
import { h5NavTrack, panelStateStore } from '../misc';
import { isBrowser } from '../../../../utils/trick';
import { scTrack } from '../../../../utils/scTrack';
import { DOWNLOAD_LINK } from '../../../../utils/url';
import './style.scss';
import { ArrowchevronRightIcon } from '@bfe/moly-icons';

export type MainMenuProps = {};

export function MainMenu(_props: MainMenuProps) {
  const { locale, t } = useLocale();
  const { panel } = panelStateStore.useStoreState();

  const langItem = invoke(() => LOCALES.find((v) => v.value === locale));

  const goDownload = () => {
    if (!isBrowser) return;
    scTrack('Web3H5MoreSettingPageClick', { plate_area: 'Download' });
    window.location.href = DOWNLOAD_LINK;
  };

  return (
    <div className="mt-14">
      <div className="site-switch">
        <a
          href={`/${locale}`}
          className="site-switch-item"
          onClick={() => {
            h5NavTrack('Bybit');
          }}
        >
          {t('exchange')}
        </a>
        <a
          href={`/${locale}/web3/home`}
          className="site-switch-item is-active"
          onMouseDown={() => {
            h5NavTrack('Home');
          }}
        >
          WEB3
        </a>
      </div>
      <ul className="sidebar-list mt-3">
        <li onClick={() => panelStateStore.setState('panel', 'lang')}>
          <div>{t('language')}</div>
          <div className="flex items-center">
            <span>{langItem?.label}</span>
            <ArrowchevronRightIcon color="var(--bds-gray-t3)" width={18} className="m-2" />
          </div>
        </li>
        <li onClick={() => web3Navigate(replacePath('/web3/crypto-ark'))}>
          <div>{t('TheCryptoArk')}</div>
        </li>
        <li onClick={goDownload}>{t('download_bybit')}</li>
      </ul>
    </div>
  );
}
